import { AfterViewInit, Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { WbDataLiveCalls } from '../models/wb-base-item';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatRowDef, MatRow } from '@angular/material/table';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { PbxWbAgentModel } from '../../../api/models/pbx-wb-agent-model';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, NgStyle } from '@angular/common';
import { DurationTimerComponent } from '../../../core/visual/duration-timer/duration-timer.component';
import { SipContactPipe } from '../../../core/pipes/sip-contact.pipe';

interface LiveCallTableRow {
  activeCall: string;
  startTime: Date;
}

@Component({
    selector: 'app-pbx-wb-live-calls-widget',
    template: `
    <div fxLayout="column" fxFlexFill>
      <div fxLayout="column" fxLayoutAlign="center center" class="wb-type-counter">
        <span class="wb-type-counter-value">{{ total }}</span>
      </div>
      <div fxFlex="auto" fxFlexFill class="table-container">
        <mat-table [dataSource]="dataSource" [multiTemplateDataRows]="true" class="regular-table responsive"
                   matSort matSortActive="duration" matSortDirection="desc" matSortDisableClear>

          <ng-container matColumnDef="activeCall">
            <mat-header-cell *matHeaderCellDef mat-sort-header="activeCall">Live Calls</mat-header-cell>
            <mat-cell *matCellDef="let row">
              <span class="mobile-label">Live Calls:</span>
              <span class="row-text" style="white-space: pre;">{{ row.activeCall | sipContact }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="duration">
            <mat-header-cell *matHeaderCellDef mat-sort-header="duration">Duration</mat-header-cell>
            <mat-cell *matCellDef="let row">
              <span class="mobile-label">Duration:</span>
              <div style="display: flex; flex-direction: column; justify-content: center; align-items: flex-end;">
                <div style="font-weight: bold" [ngStyle]="{'color':'rgb(57, 203, 118)'}" *ngIf="row.agent">{{row.agent}}</div>
                <app-duration-timer [startTime]="row.startTime"></app-duration-timer>
              </div>
            </mat-cell>
          </ng-container>

          <!-- Header and Row Declarations -->
          <!--<mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>-->
          <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
        </mat-table>
      </div>
    </div>
  `,
    styles: [
        `
      :host {
        display: block;
        width: 100%;
        height: 100%;
        padding: 5px;
      }

      .wb-type-counter {
        padding: 20px 10px;
        font-size: 40px;
        font-weight: 600;
        color: #3D3D3D;
      }

      .mat-column-activeCall {
        max-width: 400px;
        min-width: 100px;
        white-space: nowrap;

        .row-text {
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .mat-column-duration {
        max-width: 100px;
        min-width: 100px;
        display: flex;
        flex-direction: row;
        justify-content: end;
      }
    `,
    ],
    standalone: true,
    imports: [
        FlexModule,
        MatTable,
        MatSort,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatSortHeader,
        MatCellDef,
        MatCell,
        NgIf,
        NgStyle,
        DurationTimerComponent,
        MatRowDef,
        MatRow,
        SipContactPipe,
    ],
})
export class WbLiveCallsWidgetComponent implements OnChanges, AfterViewInit {
  @Input() itemData: WbDataLiveCalls;
  @Input() agentsData: Array<PbxWbAgentModel>;
  @ViewChild(MatSort) sort: MatSort;

  total: number;
  dataSource = new MatTableDataSource<LiveCallTableRow>([]);
  displayedColumns = ['activeCall', 'duration'];

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.total = this.itemData?.calls?.length || 0;
    this.dataSource.data = (this.itemData?.calls || []).map(x => {
      return {
        activeCall: x.from,
        startTime: new Date(x.start),
        agent: x.agent,
      }
    })
  }
}
